<template>
  <v-card :loading="loading" class="pa-2 rounded-lg ma-4" outlined>
    <v-card-title>
      ویرایش {{ tempContent.time }}
      <v-spacer/>

      <v-btn v-if="hasReturn" :disabled="loading" class="mx-1" color="red" text @click="$emit('close')">
        بازگشت
        <v-icon right>mdi-close</v-icon>
      </v-btn>

      <v-btn :disabled="!tempContent.time || !tempContent.title" :loading="loading" color="success" outlined
             @click="saveChange">
        ذخیره تغییرات
        <v-icon right>mdi-chevron-left</v-icon>
      </v-btn>
    </v-card-title>

    <v-row no-gutters>
      <v-col class="pa-2" cols="12" md="6">
        <v-text-field v-model="tempContent.title" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable
                      dense label="عنوان" outlined persistent-hint/>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <custom-date-picker v-model="tempContent.time" class="rounded-lg" dense expression="HH:mm" format="time"
                            input-class="time-edit" label="ساعت" outlined persistent-hint
                            prepend-inner-icon="mdi-clock-outline" readonly/>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <price-input v-model="tempContent.price" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable
                     dense label="مبلغ هر نوبت (ریال)" min="1" outlined persistent-hint/>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <v-text-field v-model="tempContent.discount" append-icon="mdi-percent-outline" class="rounded-lg"
                      clear-icon="mdi-close-circle-outline" clearable dense label="تخفیف" outlined persistent-hint/>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <v-switch v-model="inActiveSwitch" :disabled="!['notReserved', 'inactive'].includes(tempContent.status)" dense
                  hint="غیرفعال کردن نوبت" label="غیرفعال" persistent-hint @change="changeStatus"/>
      </v-col>
    </v-row>

    <v-card flat>
      <v-card-title>ویژگی‌های نوبت</v-card-title>
      <extra-fileds v-model="tempContent.details" block/>
    </v-card>
  </v-card>
</template>

<script>
import CustomDatePicker from "@/view/content/custom-date-picker.vue";
import PriceInput from "@/core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
import ExtraFileds from "@/view/components/Product/extraFileds.vue";

export default {
  name: "editAppointmentHour",

  components: {ExtraFileds, PriceInput, CustomDatePicker},

  props: {
    value: Object,
    hasReturn: {
      type: Boolean,
      default: true
    },
    hours: {
      type: Array,
      default: []
    }
  },

  data: () => ({
    tempContent: {},
    loading: false,
    inActiveSwitch: false
  }),

  mounted() {
    this.inActiveSwitch = this.value?.status === 'inactive'

    this.tempContent = !!this.value ? {...this.value} : {
      title: "ساعت",
      description: "",
      time: "",
      price: 0,
      discount: "0",
      details: [],
      status: 'notReserved'
    }
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
  },

  methods: {
    saveChange() {
      this.computedValue = this.tempContent
      this.$emit('save', this.tempContent)
    },
    changeStatus(e) {
      this.tempContent.status = e ? 'inactive' : 'notReserved'
    }
  }
}
</script>

<style scoped>

</style>